

<app-product-list-item *ngFor="let product of products"
                        [product]="product"
                        [combinedFacets]="combinedFacets"
                        [catalogItemPageSettings]="catalogItemPageSettings"
                        [isFavorite]="isFavorite(product)"
                        [cartProduct]="cartProduct(product)"
                        [allowOutOfStockOrdering]="allowOutOfStockOrdering"
                        (onDetails)="openDetails($event)"
                        (onFavoriteToggle)="toggleFavorite($event)"
                        [quantityPicker]="quantityPicker"
                        (onAddCart)="addCart($event)">
</app-product-list-item>
